module.exports = __webpack_public_path__ + "static/media/house-5.721effb4.jpeg";